<template>
    <rd-container size="large">
        <rd-header :title="$t('index.title', { totalCount : getPzzDepartmentUsersTotalCount })">
            <dx-button :use-submit-behavior="false"
                       type="default"
                       :text="$t('buttons.addUser')"
                       @click="showAddPopup">
            </dx-button>
            <dx-button :use-submit-behavior="false"
                       type="default"
                       class="ml-1"
                       :text="$t('buttons.addRole')"
                       @click="showAddRolePopup">
            </dx-button>
        </rd-header>


        <div class="row">
            <rd-column :size="$columns.TwelveOnLg">

                <!-- Grid -->
                <dx-data-grid :data-source="getPzzDepartmentUsersList"
                              :remote-operations="true"
                              :allow-column-resizing="true"
                              :column-auto-width="false"
                              :control-column-resizing="false"
                              :repaint-changes-only="true"
                              :allow-column-reordering="true"
                              :row-alternation-enabled="true"
                              :hover-state-enabled="true"
                              class="main-datagrid"
                              ref="gridData">
                    <dx-filter-row :visible="true"
                                   apply-filter="auto"
                                   :show-operation-chooser="false" />
                    <dx-column data-field="UserGroup"
                               :caption="$t('index.captions.userGroup')"
                               data-type="string" />
                    <dx-column data-field="Department"
                               :caption="$t('index.captions.departmentName')"
                               data-type="string" />
                    <dx-column data-field="OrderType"
                               :caption="$t('index.captions.orderTypeName')"
                               data-type="string" />
                    <dx-column data-field="DepartmentAccessType"
                               :caption="$t('index.captions.departmentAccessType')"
                               data-type="lookup">
                        <dx-lookup :search-enabled="true"
                                   :data-source="getAccessTypes"
                                   display-expr="Text"
                                   value-expr="Value"
                                   :closeOnOutsideClick="true">
                        </dx-lookup>
                    </dx-column>
                    <dx-column data-field="AdditionalVisibility"
                               :caption="$t('index.captions.additionalVisibility')"
                               data-type="lookup">
                        <dx-lookup :search-enabled="true"
                                   :data-source="getAdditionalVisibilities"
                                   display-expr="Text"
                                   value-expr="Value"
                                   :closeOnOutsideClick="true">
                        </dx-lookup>
                    </dx-column>
                    <dx-column data-field="UserNameVisibility"
                               :caption="$t('index.captions.userNameVisibility')"
                               data-type="string" />
                    <dx-column data-field="RoleVisibility"
                               :caption="$t('index.captions.roleVisibility')"
                               data-type="string" />
                    <dx-column data-field="Id"
                               :allow-filtering="false"
                               :allow-reordering="false"
                               :allow-resizing="false"
                               alignment="center"
                               :width="175"
                               :caption="$t('index.captions.actions')"
                               cell-template="cellTemplate" />
                    <dx-pager :allowed-page-sizes="pageSizes"
                              :show-page-size-selector="true" />
                    <dx-paging :page-size="30" />
                    <div slot="cellTemplate" slot-scope="{ data }">
                        <!--<router-link :to="{name: 'dictionaries.branches.details', params: {id: data.value}}">
                            <dx-button styling-mode="text" :hint="$t('buttons.details')" :title="$t('buttons.details')" icon="fas fa-list" type="normal" class="datagrid-button" />
                        </router-link>-->
                        <!--<span :hint="$t('buttons.edit')" :title="$t('buttons.edit')" class="main-datagrid-btn" @click="showEditPopup(data)"><i class="fas fa-pen"></i></span>-->
                        <span :hint="$t('buttons.delete')" :title="$t('buttons.delete')" class="main-datagrid-btn" @click="showDeletePopup(data)"><i class="fas fa-trash"></i></span>
                    </div>
                    <dx-paging :page-size="30" />
                </dx-data-grid>

                <!-- Delete -->
                <rd-popup :visibility="popupOptions.popupVisible" :title="$t('popup.title.deleteAccess')">
                    <rd-popup-content>
                        <ul>
                            <li v-for="(item, index) in popupOptions.fields" v-bind:key="index" style="list-style-type: none;">
                                <label>{{item.name}}: </label> {{item.value}}
                            </li>
                        </ul>
                    </rd-popup-content>
                    <rd-popup-actions>
                        <dx-button :type="cancelBtnOption.type" styling-mode="text" :text="cancelBtnOption.text" @click="function(){ popupOptions.popupVisible = false; }" />
                        <dx-button :type="deleteBtnOption.type" class="ml-1" :text="deleteBtnOption.text" @click="deletePzzDepartmentUsersPopup(popupOptions.id)" />
                    </rd-popup-actions>
                </rd-popup>

                <!-- AddUser -->
                <addUserForm ref="addUserForm" @added="refreshGrid"></addUserForm>

                <!-- AddRole -->
                <addRoleForm ref="addRoleForm" @added="refreshGrid"></addRoleForm>

                     
            </rd-column>
        </div>
    </rd-container>
</template>
<script>
    // @ is an alias to /src
    import {
        DxDataGrid,
        DxColumn,
        DxFilterRow,
        DxPager,
        DxPaging,
        DxLookup
    } from 'devextreme-vue/data-grid';
    import DxButton from 'devextreme-vue/button';

    import { mapFields } from 'vuex-map-fields';
    import { mapGetters, mapActions } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import addUserForm from './AddUser';
    import addRoleForm from './AddRole';

    const name = "administrationStores/dictionariesStores/pzzDepartmentUsersStores/indexStore";
    const edit = "administrationStores/dictionariesStores/pzzDepartmentUsersStores/editStore";

    export default {
        name: 'appBranchesList',
        data() {
            return {
                popupOptions: {
                    popupVisible: false,
                    id: null,
                    fields: [
                        {
                            name: this.$t('index.captions.userGroup'),
                            value: ''
                        },
                        {
                            name: this.$t('index.captions.departmentName'),
                            value: ''
                        },
                        {
                            name: this.$t('index.captions.orderTypeName'),
                            value: ''
                        },
                        {
                            name: this.$t('index.captions.departmentAccessType'),
                            value: ''
                        },
                        {
                            name: this.$t('index.captions.additionalVisibility'),
                            value: ''
                        },
                        {
                            name: this.$t('index.captions.userNameVisibility'),
                            value: ''
                        },
                        {
                            name: this.$t('index.captions.roleVisibility'),
                            value: ''
                        },
                    ]
                },
                cancelBtnOption: {
                    type: "normal",
                    text: this.$t('buttons.cancel'),
                },
                deleteBtnOption: {
                    type: "danger",
                    text: this.$t('buttons.delete'),
                },
                addBtnOptions: {
                    type: "default",
                    text: this.$t('buttons.add')
                },
                editPopupOptions: {
                    popupVisible: false,
                },
                pageSizes: [30, 50, 100]
            }
        },
        computed: {
            ...mapGetters(name, ['getPzzDepartmentUsersList', 'getPzzDepartmentUsersTotalCount', 'getAccessTypes', 'getAdditionalVisibilities']),
            ...mapFields(name, [
            ]),
        },
        methods: {
            ...mapActions(name, ['setLoaded', 'setPzzDepartmentUsersTotalCount', 'deletePzzDepartmentUsers', 'setListData']),
            ...mapActions(edit, ['setEditDetails']),
            refreshGrid() {
                this.$refs.gridData.instance.refresh();
            },
            showDeletePopup(options) {
                
                this.popupOptions.fields[0].value = options.data.UserGroup;
                this.popupOptions.fields[1].value = options.data.Department;
                this.popupOptions.fields[2].value = options.data.OrderType;
                this.popupOptions.fields[3].value = options.row.cells[3].displayValue;
                this.popupOptions.fields[4].value = options.row.cells[4].displayValue;
                this.popupOptions.fields[5].value = options.data.UserNameVisibility;
                this.popupOptions.fields[6].value = options.data.RoleVisibility;

                this.popupOptions.id = options.data.Id;
                this.popupOptions.popupVisible = true;
            },
            deletePzzDepartmentUsersPopup(recordId) {
                this.deletePzzDepartmentUsers(recordId).then(() => {
                    this.$refs.gridData.instance.refresh();
                    this.popupOptions.popupVisible = false;
                });
                
            },
            showAddPopup() {
                this.$refs.addUserForm.show();
            },
            showAddRolePopup() {
                this.$refs.addRoleForm.show();
            },
            showEditPopup(options) {
                this.setEditDetails(options.data.Id);
                this.editPopupOptions.popupVisible = true;
            },
            onEditPopupClose() {
                this.editPopupOptions.popupVisible = false;
            }
        },
        mounted() {
            var gridInstance = this.$refs.gridData.instance;
            var setPzzDepartmentUsersTotalCount = this.setPzzDepartmentUsersTotalCount;
            this.setLoaded(() => {
                this.totalCount = setPzzDepartmentUsersTotalCount(gridInstance.totalCount());
            });
            this.setListData();
        },
        components: {
            DxDataGrid,
            DxColumn,
            DxFilterRow,
            DxPager,
            DxPaging,
            DxButton,
            DxLookup,
            addUserForm,
            addRoleForm
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>